// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d867c366","389":"17de0bb6","455":"3ae651c4","857":"ec4baa08","977":"ff28253c"}[chunkId] + ".chunk.js";
};